var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-item"},[_c('span',{staticClass:"text--white"},[_vm._v(_vm._s(_vm.rating))]),_c('v-icon',{staticClass:"ml-1",staticStyle:{"top":"-3.5px"}},[_vm._v("mdi-star")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }